module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-rewards-64-active.bd17031c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-rewards-64-active.png
// module id = 3202
// module chunks = 11